/**
 * @fileoverview POST handler for the "/engagement/campaigns/restore_campaign_retargeting_data" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementCampaignsRestoreCampaignRetargetingDataCacheKeys } from "./constants";
import type {
  PostEngagementCampaignsRestoreCampaignRetargetingDataProps,
  EngagementCampaignsRestoreCampaignRetargetingDataResult,
} from "./types";

export const postEngagementCampaignsRestoreCampaignRetargetingData = reactQueryMutationAdapter(
  engagementCampaignsRestoreCampaignRetargetingDataCacheKeys,
  (
    props: PostEngagementCampaignsRestoreCampaignRetargetingDataProps
  ): Promise<EngagementCampaignsRestoreCampaignRetargetingDataResult> => {
    return fetch("/engagement/campaigns/restore_campaign_retargeting_data", "POST", props);
  }
);
